import { css } from "aphrodite";
import { CustomAppBar } from "./components/CustomAppBar";
import { CustomFooter } from "../common/components/CustomFooter";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import "../common/components/AccessibleLink/AccessibleLink.css";

const Layout = ({ children, webView = true }) => {
    const { t } = useTranslation(["translation"]);

    return (
        <div className={css(styles.container)}>
            <a href="#main-content" className={css(styles.skipLink)}>
                {t("skipToMainContent")}
            </a>
            <CustomAppBar webView={webView} />
            <main
                id="main-content"
                tabIndex={-1}
                className={css(styles.contentWrapper)}
            >
                {children}
            </main>
            <CustomFooter webView={webView} />
        </div>
    );
};

export default Layout;
